import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { createTeam, editTeam } from './form.thunks';

export interface TeamFormState {
  loading: boolean;
  error: string | null;
}

export const initialState: TeamFormState = {
  error: null,
  loading: false
};

const getTeamForm = (state: RootState): TeamFormState => state.teams.form;

export const selectors = {
  getTeamForm
};

export const extraReducers = {
  [createTeam.pending.type]: (state: TeamFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [createTeam.fulfilled.type]: (state: TeamFormState): void => {
    state.loading = false;
  },
  [createTeam.rejected.type]: (state: TeamFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [editTeam.pending.type]: (state: TeamFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [editTeam.fulfilled.type]: (state: TeamFormState): void => {
    state.loading = false;
  },
  [editTeam.rejected.type]: (state: TeamFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {},
  extraReducers
});

export default formSlice.reducer;

export const actions = formSlice.actions;
export const caseReducers = formSlice.caseReducers;
